import type { StickyData } from './types';

export function isValidData(value: unknown): value is StickyData {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    (typeof v.text === 'string' || (typeof v.text === 'object' && v.text !== null)) &&
    typeof v.fill === 'string' &&
    typeof v.fillOpacity === 'number' &&
    typeof v.strokeOpacity === 'number' &&
    (v.textAlign === 'left' || v.textAlign === 'center' || v.textAlign === 'right') &&
    typeof v.fontSize === 'number'
  );
}
